export default __webpack_public_path__ + "static/media/Verda.c569d395.jpg";